import { ChatApplyController } from './chatApplyInterface';
import { ChatApplyControllerProps, ChatApplyOperationProps } from './chatApplyProps';
import { generateDiffSquares } from './chatApplyHelper';
import { ChatApplyAggregate } from './chatApplyModel';
import { AssistantSuggestionOperation } from '@varos/assistant-sdk';
import { HiOutlineDocumentText } from 'react-icons/hi';

export function createChatApplyController(): ChatApplyController {
    function getStatus(
        item: ChatApplyAggregate & {
            operation: AssistantSuggestionOperation;
        },
        props: ChatApplyControllerProps,
        index: number
    ): ChatApplyOperationProps['status'] {
        if (item.suggestion === null) {
            return {
                kind: 'skipped',
                label: 'Skipped',
            };
        }

        const operation = item.suggestion.operations[index] ?? null;
        if (operation === null) {
            return {
                kind: 'skipped',
                label: 'Skipped',
            };
        }
        if (operation.status === 'accepted') {
            return {
                kind: 'accepted',
                label: 'Accepted',
            };
        }
        if (operation.status === 'rejected') {
            return {
                kind: 'rejected',
                label: 'Rejected',
            };
        }
        return {
            kind: 'pending',
            accept: {
                label: 'Accept',
                button: {
                    onClick() {
                        return props.onAccept(operation, index);
                    },
                },
            },
            reject: {
                label: 'Reject',
                button: {
                    onClick() {
                        return props.onReject(operation, index);
                    },
                },
            },
        };
    }
    return {
        useProps(context, item, props) {
            return {
                document: {
                    label: item.content.title ?? 'Content no longer available',
                    icon: item.content.icon
                        ? {
                              kind: 'emoji',
                              text: item.content.icon,
                          }
                        : {
                              kind: 'icon',
                              Component: HiOutlineDocumentText,
                          },
                    onClick() {
                        props.onOpen();
                    },
                },
                operations: item.tool.args.suggestion.operations.map(
                    (operation, index): ChatApplyOperationProps => {
                        const addedValue = 3;
                        const removedValue = 2;
                        return {
                            id: index.toString(),
                            summary: {
                                added: {
                                    value: addedValue,
                                    label: `+${addedValue}`,
                                },
                                removed: {
                                    value: removedValue,
                                    label: `-${removedValue}`,
                                },
                                visual: {
                                    squares: generateDiffSquares(
                                        addedValue,
                                        removedValue
                                    ),
                                },
                            },
                            status: getStatus({ ...item, operation }, props, index),
                        };
                    }
                ),
            };
        },
    };
}
